// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
    LINK: '[data-fragment="EshopProductListTile.link"]',
    RADIO: '[data-fragment="EshopProductListTile.radio"]',
    MOTIVE_IMG: '[data-fragment="EshopProductListTile.motiveImg"]',
    MOTIVE_SOURCE: '[data-fragment="EshopProductListTile.motiveSource"]',
    MOTIVE_SOURCE_WEBP: '[data-fragment="EshopProductListTile.motiveSourceWebp"]'
};

export default class EshopProductListTile extends WebComponent {
    constructor(props) {
        super(props);
        this.modifyTile = this.modifyTile.bind(this);
    }

    didMount() {
        const self = this;
        this.link = this.element.querySelector(fragments.LINK);
        this.colorSelectInput = this.element.querySelectorAll(fragments.RADIO);
        this.stockInfoText = this.element.querySelector('.stock-info__text > span');
        this.motiveImg = this.element.querySelector(fragments.MOTIVE_IMG);
        this.motiveSource = this.element.querySelector(fragments.MOTIVE_SOURCE);
        this.motiveSourceWebp = this.element.querySelector(fragments.MOTIVE_SOURCE_WEBP);

        // varianty na dlaždici
        if(this.colorSelectInput) {
            this.colorSelectInput.forEach(function(input) {
                input.addEventListener('click', function(e) {
                    e.preventDefault();
                    self.colorSelectInput.forEach(function(item) {
                        item.classList.remove('checked');
                        item.checked = false;
                    })
                    this.classList.add('checked');
                    self.modifyTile(self.element.dataset.productCode, this.value);
                });
            });

        }
        // kotva na předchozí stránku
        this.link.addEventListener('click', function(e) {
            let url = window.location.href.split('#')[0];

            url = url.replace(/productListing\.page=(\d)+/, 'productListing.page='+self.element.dataset.pageNumber);

            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            window.history.replaceState('Object', 'Title', url + '#' + self.element.id);
        });
    }

    // načtení JSON a změna dlaždice
    modifyTile(productCode, parameterCode) {
        const self = this;
        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
                let json = JSON.parse(this.responseText);
                self.stockInfoText.innerHTML = json.availabilityText;
                self.stockInfoText.className = json.availabilityClass;
                self.link.href = json.variantUrl;
                if (json.mainMotive != null && json.mainMotiveX2 != null) {
                    self.motiveImg.src = json.mainMotive;
                    self.motiveSource.srcset = json.mainMotive+ ' 1x, '+ json.mainMotiveX2+ ' 2x';
                    if (self.motiveSourceWebp) {
                        self.motiveSourceWebp.srcset = json.mainMotive.replace('.jpg','.webp')+ ' 1x, '+ json.mainMotiveX2.replace('.jpg','.webp')+ ' 2x';
                    }
                }
            }
        };
        xhttp.open('GET', '/'+window.projectConfig.lang+'/entity-data/color-variant-summary/'+productCode+'/'+parameterCode+'/', true);
        xhttp.send();
    }

}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/EshopProductListTile.js